import { connect } from 'react-redux';

import { selectors } from 'dux/org';

import PromotionCard from './PromotionCard';

const mapStateToProps = (state) => ({
  org: selectors.getOrgState(state),
});

export default connect(mapStateToProps, null)(PromotionCard);
